import { render, staticRenderFns } from "./SignOutFailed.vue?vue&type=template&id=08145923&scoped=true"
import script from "./SignOutFailed.vue?vue&type=script&lang=js"
export * from "./SignOutFailed.vue?vue&type=script&lang=js"
import style0 from "./SignOutFailed.vue?vue&type=style&index=0&id=08145923&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08145923",
  null
  
)

export default component.exports